import * as React from 'react'; 
import { Routes, Route } from 'react-router-dom'
import Dashboard from './Landing/Dashboard/Dashboard';
import AdmNotificaciones from './Notificaciones/AdmNotificaciones';
import AdmPublicaciones from './Publicaciones/AdmPublicaciones';
import AdmOrdenes from './Ordenes/AdmOrdenes';
import AdmSellers from './Sellers/AdmSellers';
import AdmUsuarios from './Usuarios/AdmUsuarios';
import ListRebates from './Rebates/ListRebates';
import AdmPlanes from './Planes/AdmPlanes';
import AdmTipoPublicaciones from './TipoPublicaciones/AdmTipoPublicaciones';
import AdmExportables from './Exportables/AdmExportables';
import AdmLiquidaciones from './Liquidaciones/Liquidaciones/AdmLiquidaciones';
import AdmNovedades from './Liquidaciones/Novedades/AdmNovedades';
import AdmConceptos from './Liquidaciones/Conceptos/AdmConceptos';
import AdmOrdenesProveedores from './Ordenes/Proveedores/AdmOrdenesProveedores';
import BusquedaGlobalResultados from './BusquedaGlobalResultados';
import AdmProveedores from './Proveedores/AdmProveedores';

export default class Container extends React.Component {
    render() {
        return (
            <div className="page-wrapper">
                <div className="container-fluid">
                    <Routes>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/BusquedaGlobalResultados" element={<BusquedaGlobalResultados />} />
                        <Route path="/Notificaciones/*" element={<AdmNotificaciones />} />
                        <Route path="/Sellers/*" element={<AdmSellers />} />
                        <Route path="/Usuarios/*" element={<AdmUsuarios />} />
                        <Route path="/Publicaciones/*" element={<AdmPublicaciones />} />
                        <Route path="/Ordenes/*" element={<AdmOrdenes />} />
                        <Route path="/OrdenesProveedores/*" element={<AdmOrdenesProveedores />} />
                        <Route path="/Proveedores/*" element={<AdmProveedores />} />
                        <Route path="/Rebates" element={<ListRebates />} />
                        <Route path="/Planes/*" element={<AdmPlanes />} />
                        <Route path="/Tipo/Publicaciones/*" element={<AdmTipoPublicaciones />} />
                        <Route path="/Exportables/*" element={<AdmExportables />} />
                        <Route path="/Novedades/*" element={<AdmNovedades />} />
                        <Route path="/Liquidaciones/*" element={<AdmLiquidaciones />} />
                        <Route path="/Conceptos/*" element={<AdmConceptos />} />
                    </Routes>
                </div>
            </div>
        );
    }
}
